<template>
  <div class="sc-typing-indicator">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>
<script>
export default {
 
}
//
</script>
<style scoped>
.sc-typing-indicator {
  padding: 3px 0px;
  border-radius: 6px;
}

.sc-typing-indicator span {
  display: inline-block;
  background-color: #B6B5BA;
  width: 7px;
  height: 7px;
  border-radius: 100%;
  margin-right: 2px;
  animation: bob 2s infinite;
}

 /*SAFARI GLITCH */
.sc-typing-indicator span:nth-child(1) {
  animation-delay: -1s;
}
.sc-typing-indicator span:nth-child(2) {
  animation-delay: -0.85s;
}
.sc-typing-indicator span:nth-child(3) {
  animation-delay: -0.7s;
}

@keyframes bob {
  10% { 
    transform: translateY(-10px);
    background-color: #9E9DA2;
  }
  50% {
    transform: translateY(0);
    background-color: #B6B5BA;
  }
}
</style>
